import { useNavigate } from 'react-router-dom';
import { CheckCircleRounded, RadioButtonUncheckedRounded } from '@mui/icons-material';
import PreviewInfo from './PreviewInfo';
import { canOpenSpeakerProfile } from './speakerHelper';
import { safeSavedEpisodeStart } from '../utils/savedPreviewCache';

export default function SavedHighlightRow({ record, onPlay, selectionMode, selectionDisabled, selected, onSelect }) {
    const { preview } = record;
    const navigate = useNavigate();
    const canPlay = record.available && Boolean(preview.mp3URL?.trim());
    const start = safeSavedEpisodeStart(record);
    const openEpisode = () => {
        if (!record.fullEpisodeAvailable) return;
        navigate(`/track/${encodeURIComponent(preview.fullTrackId)}${start === null ? '?autoplay=false' : `?start=${start}`}`);
    };
    return <div className={`savedHighlightRow${selectionMode ? ' savedHighlightRowSelectable' : ''}`}>
        <div aria-hidden={selectionMode || undefined} inert={selectionMode ? '' : undefined}>
            <PreviewInfo
                preview={preview}
                playPreview={onPlay}
                disablePlayback={!canPlay || selectionMode}
                disableFullEpisode={!record.fullEpisodeAvailable}
                onFullEpisodeClick={openEpisode}
                onSourceClick={sourceId => navigate(`/podcast/${encodeURIComponent(sourceId)}`)}
                onSpeakerClick={speaker => {
                    if (!selectionMode && canOpenSpeakerProfile(speaker)) navigate(`/speaker/${encodeURIComponent(speaker.id)}`);
                }}
                showFooterControls={!selectionMode}
                className='previewInfoVerticalListCard'
            />
            {!record.available && <div className='savedHighlightUnavailable'>Highlight unavailable</div>}
            {!record.available && record.fullEpisodeAvailable && !selectionMode &&
                <button type='button' className='savedHighlightEpisodeFallback' onClick={openEpisode}>
                    {start === null ? 'Open episode' : 'Play full episode'}
                </button>}
        </div>
        {selectionMode && <button type='button' className='savedHighlightSelectionButton'
            disabled={selectionDisabled}
            aria-label={`${selected ? 'Deselect' : 'Select'} ${preview.title}`} aria-pressed={selected} onClick={onSelect}>
            {selected ? <CheckCircleRounded /> : <RadioButtonUncheckedRounded />}
        </button>}
    </div>;
}
